// extracted by mini-css-extract-plugin
export default {"container":"SummerDealBanner-module__container___VaVX7"};